import React from 'react';

import {FilterInput} from 'src/components/input';
import {useUserAlerts} from 'src/modules/profile/user/tabs/content/alerts/hooks/useUserAlerts';
import {SCOPE_KEY} from 'src/modules/profile/user/tabs/content/alerts/util';

import {BoxLoading} from '@pb/kit-component-box-loading';
import {Group} from '@pb/kit-component-group';
import {StickyElement} from '@pb/kit-component-sticky-element';
import Typography from '@pb/kit-component-typography';

import {CONTENT_SUBTAB_SCOPE, ContentTabs} from '../content-tabs';
import {container, panel} from '../content.module.styl';


import {SavedAlertTable} from './alert-table';


type Props = {
    userId: number,
};

export const UserSearchAlerts = ({userId}: Props) => {
    const {
        criteria,
        isFetching,
        setCriteria,
        data,
        setPage,
        setPageSize,
        total,
    } = useUserAlerts({scopeKey: SCOPE_KEY, userId});

    const {total: alertsTotal} = useUserAlerts({scopeKey: CONTENT_SUBTAB_SCOPE, userId});
    const isNoAlerts = !alertsTotal || alertsTotal === 0;

    return (
        <>
            <StickyElement id="sticky-element">
                <ContentTabs userId={userId} activeTab="alerts"/>
                <Group direction="h" gap="xxl" className={panel}>
                    <Typography fontWeight="semi-bold" variant="heading-level-3">Alerts</Typography>
                    <FilterInput
                        id="user-search-alerts-filter"
                        placeholder="Search for alerts by name"
                        onChange={value => setCriteria({alertName: value})}
                        onClear={() => setCriteria({alertName: undefined})}
                        timeOut={1000}
                        disabled={isNoAlerts}
                        width={345}
                        value={criteria?.alertName || ''}
                    />
                </Group>
            </StickyElement>

            <BoxLoading loading={isFetching}>
                <Group className={container}>
                    <SavedAlertTable
                        userId={userId}
                        isNoAlerts={isNoAlerts}
                        total={total}
                        data={data}
                        criteria={criteria}
                        setPage={setPage}
                        setPageSize={setPageSize}
                    />
                </Group>
            </BoxLoading>
        </>
    );
};
